(ns com.theplantscape.plant-web.components.history
  (:require
   [reagent.core :as r]
   [reitit.frontend.easy :as rfe]))


(defn ui-history [id items]
  (when (> (count items) 1)
    [:ul.list.pl0.ml0.center.mw2.ba.b--light-silver.br3
     (map-indexed
      (fn [idx item]
        [:li.center.ph2.pv2.bb.b--light-silver {:key idx}
         [:a {:href (rfe/href :plant-revision {:plant-id id :revision idx})} idx]])
        
        items)]))
